import styled, { css } from "styled-components";

export const ContainerChaveApi = styled.div`
  text-align: left;
  color: ${(props) => props.theme.colors.tertiary};

  .descricao-texto{
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding: 5rem 0;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }
  }

  .bloco-input {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 3rem;
    .pai-botao {
      white-space: nowrap;
      display: flex;
      justify-content: flex-end;
      margin: 2rem 0;
    }
    @media (max-width: 470px) {
      flex-direction: column;
      align-items: flex-start;
      .pai-botao {
        margin-top: 2rem;
      }
    }
  }
`;

export const ContainerConfiguracoes = styled.div`
  .texto {
    text-align: justify;
  }
  margin-top: 4rem;
  color: ${(props) => props.theme.colors.tertiary};
  .config {
    display: flex;
    align-items: center;
    margin: 2rem 0;
    .title {
      margin-left: 2rem;
      &.bloqueado {
        opacity: 0.5;
      }
    }
    > .locked-icon {
      margin-left: 1.5rem;
    }
  }
  
  .title_ERP {
      text-align: left;
      padding-top: 2rem;
      padding-bottom: 1rem;
    }
`;
